import React, { useEffect, useRef } from "react";

import { isRunTime } from "../../utils/isRunTime";

const Input = ({
  label,
  id,
  onChange,
  value,
  autocomplete,
  type = "text",
  errorMessage,
  colors = {
    border: '#efeff4',
    text: '#242426',
    error: '#e80003',
    inputBg: '#fff',
    focus: '#3560DA',
    greyText: '#75757D'
  },
  inputButton,
  inputButtonStyle = "default",
  disabled = false,
  focusOnRender = false,
  required = false
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (focusOnRender) handleClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isRunTime() && document.getElementById(id) && errorMessage !== undefined) {
      document.getElementById(id).setCustomValidity(errorMessage || "")
    }
    // eslint-disable-next-line
  }, [errorMessage]);

  const handleClick = () => {
    ref.current.focus();
  };

  const renderInputButton = inputButtonStyle === "secondary"
    ?
      <div className={`absolute right-0 top-0 flex  ${errorMessage ? "" : "top-0"}`}>
        {inputButton}
      </div>
    :
      <div className={`absolute right-0 mr-2 h-full flex items-center ${errorMessage ? "bottom-2" : "top-0"}`}>
        {inputButton}
      </div>

  return (
    <div className="relative flex-1"
      onClick={() => handleClick()}
      role="button"
      tabIndex={0}
      onKeyDown={() => handleClick()}
      style={{ '--border': colors.border, '--text': colors.text, '--error': colors.error, '--inputBg': colors.inputBg, '--focus': colors.focus, '--greyText': colors.greyText }}
    >
      <input
        ref={ref}
        type={type}
        id={id}
        className={`block px-2.5 pb-2.5 pt-4 w-full text-base semiboldFontFamily text-[color:var(--text)] bg-transparent rounded-lg border-1 border-[color:var(--border)] appearance-none
        focus:outline-none focus:ring-0 focus:border-[color:var(--focus)] peer invalid:border-[color:var(--error)] invalid:text-[color:var(--error)] focus:text-[color:var(--text)] ${disabled ? "text-gray-400 italic" : ""}`}
        placeholder=" "
        onChange={onChange}
        value={value}
        autoComplete={autocomplete}
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={`absolute text-[color:var(--greyText)] text-base semiboldFontFamily duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-[color:var(--inputBg)] px-2
        peer-focus:px-2 peer-focus:text-[color:var(--focus)] peer-placeholder-shown:scale-100 ${errorMessage
            ? "peer-placeholder-shown:top-[calc(50%_-_0.5rem)]"
            : "peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2"
          }
         peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 peer-invalid:text-[color:var(--error)]`}
      >
        {label}
        {required ? <span className="text-[color:var(--error)]"> *</span> : ""}
      </label>
      {
        inputButton
          ?
            renderInputButton
          :
            null
      }
      <p className="max-h-0 overflow-hidden peer-invalid:max-h-16 transition-all text-[color:var(--error)] text-sm">
        {errorMessage}
      </p>
    </div>
  );
};

export default Input;
